module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn-group boot-button right_show_ctrl",
    attrs: {
      "role": "group",
      "aria-label": "..."
    }
  }, [_c('button', {
    staticClass: "btn btn-primary menu_btn right_act_btn",
    staticStyle: {
      "outline": "none",
      "border": "none"
    },
    attrs: {
      "type": "button",
      "id": "tool"
    },
    on: {
      "click": _vm.toggleMenu
    }
  }), _vm._v(" "), (_vm.isPlaying) ? _c('button', {
    staticClass: "btn btn-white",
    staticStyle: {
      "outline": "none",
      "border": "none"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.startPlay
    }
  }, [_vm._m(0)]) : _c('button', {
    staticClass: "btn btn-white",
    staticStyle: {
      "outline": "none",
      "border": "none"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.stopPlay
    }
  }, [_vm._m(1)]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-white",
    staticStyle: {
      "outline": "none",
      "border": "none"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.ceasePlay
    }
  }, [_vm._m(2)]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-white",
    staticStyle: {
      "outline": "none",
      "border": "none"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.clickSpeed('2')
      }
    }
  }, [_c('span', {
    class: {
      active: _vm.times === 2 || _vm.times === (2 / _vm.timesPlus)
    }
  }, [_vm._v("2X")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-white",
    staticStyle: {
      "outline": "none",
      "border": "none"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.clickSpeed('4')
      }
    }
  }, [_c('span', {
    class: {
      active: _vm.times === 4 || _vm.times === (4 / _vm.timesPlus)
    }
  }, [_vm._v("4X")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-white",
    staticStyle: {
      "outline": "none",
      "border": "none"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.clickSpeed('8')
      }
    }
  }, [_c('span', {
    class: {
      active: _vm.times === 8 || _vm.times === (8 / _vm.timesPlus)
    }
  }, [_vm._v("8X")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('img', {
    attrs: {
      "src": require("../../../assets/project/images/map/map_icon_7a.png"),
      "width": "20",
      "height": "20",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('img', {
    attrs: {
      "src": require("../../../assets/project/images/map/map_icon_7b.png"),
      "width": "20",
      "height": "20",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('img', {
    attrs: {
      "src": require("../../../assets/project/images/map/map_icon_79.png"),
      "width": "20",
      "height": "20",
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ed4f50a","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/didivehicletrace/VehiclePlay.vue
// module id = 1464
// module chunks = 0